import React from 'react';
import './style.css';
import RCSwitch from 'rc-switch';

const Switch = ({ children, ...rest }) => {
  return (
    <RCSwitch {...rest}>
      {children}
    </RCSwitch>
  );
};

export default Switch;
